export default __webpack_public_path__ + "static/media/Tick-fill.73c85d51.svg";